import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  buttonGroup: {
    backgroundColor: theme.palette.grey[300],
    borderRadius: 30,
  },
}));
